import { Capacitor } from '@capacitor/core'

/**
 * 环境检测工具
 */

/**
 * 判断是否为 Capacitor App 环境（iOS/Android）
 */
export const isNativeApp = () => {
  return Capacitor.isNativePlatform()
}

/**
 * 判断是否为 iOS 平台
 */
export const isIOS = () => {
  return Capacitor.getPlatform() === 'ios'
}

/**
 * 判断是否为 Android 平台
 */
export const isAndroid = () => {
  return Capacitor.getPlatform() === 'android'
}

/**
 * 判断是否为微信 H5 环境
 */
export const isWechat = () => {
  const ua = navigator.userAgent.toLowerCase()
  return ua.indexOf('micromessenger') !== -1
}

/**
 * 判断是否为浏览器 H5 环境
 */
export const isWeb = () => {
  return !isNativeApp()
}

/**
 * 获取当前环境类型
 * @returns {'ios' | 'android' | 'wechat' | 'web'}
 */
export const getEnvironment = () => {
  if (isIOS()) return 'ios'
  if (isAndroid()) return 'android'
  if (isWechat()) return 'wechat'
  return 'web'
}

export default {
  isNativeApp,
  isIOS,
  isAndroid,
  isWechat,
  isWeb,
  getEnvironment
}
